// Angular dependencies
import { Injectable } from '@angular/core';

import { AuthService, ApiService } from '../core/upgraded-providers';

@Injectable()
export class WorldConfigService {
    public CELL_SIZE: number = 100;
    public ATTACK_PENETRATION: number = 10;
    public VIEW_BOX: number = 5000;
    public ROOM_SIZE: number = 50;
    public RENDER_SIZE = {
        width: 2048,
        height: 2048,
    };

    public BADGE_URL: string = `/api/user/badge-svg?username=%1`;

    public metadata = RENDERER_METADATA;
    public gameData = {
        player: null,
        showMyNames: {
            spawns: true,
            creeps: false,
        },
        showEnemyNames: {
            spawns: true,
            creeps: false,
        },
        showFlagsNames: true,
        showCreepSpeech: true,
        swampTexture: 'animated',
    };
    public userOwnerColor = true;
    public userFlagColor = true;

    constructor(
        private _apiService: ApiService,
        private _authService: AuthService
    ) {
        const API_URL = this._apiService.options.apiUrl;

        this.BADGE_URL = `${ API_URL }user/badge-svg?username=%1`,
        this.gameData.player = this._authService.Me._id;
    }

    get() {
        const API_URL = this._apiService.options.apiUrl;

        return {
            CELL_SIZE: 100,
            ATTACK_PENETRATION: 10,
            VIEW_BOX: 5000,
            ROOM_SIZE: 50,
            RENDER_SIZE: {
                width: 2048,
                height: 2048,
            },
            BADGE_URL: `${ API_URL }user/badge-svg?username=%1`,
            // @ts-ignore
            metadata: RENDERER_METADATA,
            gameData: {
                player: this._authService.Me._id,
                showMyNames: {
                    spawns: true,
                    creeps: false,
                },
                showEnemyNames: {
                    spawns: true,
                    creeps: false,
                },
                showFlagsNames: true,
                showCreepSpeech: true,
                swampTexture: 'animated',
            },
            userOwnerColor: true,
            userFlagColor: true
        };
    }
}
